<template>
	<div>
		<img v-show="this.$i18n.locale == 'zh'" src="../../../public/index/C.png" style="width: 100%;"/>
		<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/product/fooddelivery/C1.png" style="width: 100%;"/>
		<div style="margin: auto;width: 90%;">
			<br /><br />
			<h2>{{ $t('lang.Delivery')}}{{ $t('lang.Robot')}}</h2>
			
			<div slot="header" class="clearfix black1" style="text-align: left;">
				<p class="indent" style="text-align: justify;">
				{{ $t('lang.generation')}}
				</p>
			</div>
			<img src="../../../public/pic/product/fooddelivery/产品.png" />
			<hr />
			<h2>{{ $t('lang.Video_introduction')}}</h2>

			<video width="100%" controls>
				<source src="../../../public/pic/product/fooddelivery/Demo.mp4" type="video/mp4">
				您的浏览器不支持 video 标签。
			</video>
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/fooddelivery/22.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/fooddelivery/44.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/fooddelivery/66.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/fooddelivery/77.png" />
			<hr />
			<h2>{{ $t('lang.Delivery1')}}</h2>
			
				
			<table border="5" style="border-collapse: collapse; width:100%;">
				<tr>
					<td class="black">{{ $t('lang.Delivery2')}}</td>
					<td class="black">{{ $t('lang.Delivery3')}}</td>
				</tr>
				<tr>
					<td class="black" >{{ $t('lang.Delivery4')}}</td>
					<td class="black">{{ $t('lang.Delivery5')}}</td>
				</tr>
				<tr>
					<td class="black" >{{ $t('lang.Delivery6')}}</td>
					<td class="black">{{ $t('lang.Delivery7')}}</td>
				</tr>
				<tr>
					<td class="black" >{{ $t('lang.Delivery8')}}</td>
					<td class="black">{{ $t('lang.Delivery9')}}</td>
				</tr>
				<tr>
					<td class="black" >{{ $t('lang.Delivery10')}}</td>
					<td class="black">{{ $t('lang.Delivery11')}}</td>
				</tr>
				<tr>
					<td class="black" >{{ $t('lang.Delivery12')}}</td>
					<td class="black">{{ $t('lang.Delivery13')}}</td>
				</tr>
				<tr>
					<td class="black" >{{ $t('lang.Delivery14')}}</td>
					<td class="black">{{ $t('lang.Delivery15')}}</td>
				</tr>
				<tr>
					<td class="black" >{{ $t('lang.Delivery16')}}</td>
					<td class="black">{{ $t('lang.Delivery17')}}</td>
				</tr>
				<tr>
					<td class="black" >{{ $t('lang.Delivery18')}}</td>
					<td class="black">{{ $t('lang.Delivery19')}}</td>
				</tr>
				<tr>
					<td class="black" >{{ $t('Delivery20')}}</td>
					<td class="black">{{ $t('lang.Delivery21')}}</td>
				</tr>
				<tr>
					<td class="black" >{{ $t('lang.Delivery22')}}</td>
					<td class="black">{{ $t('lang.Delivery23')}}</td>
				</tr>
				<tr>
					<td class="black" >{{ $t('lang.Delivery24')}}</td>
					<td class="black">{{ $t('lang.Delivery25')}}</td>
				</tr>
				<tr>
					<td class="black" >{{ $t('lang.Delivery26')}}</td>
					<td class="black">{{ $t('lang.Delivery27')}}</td>
				</tr>
				<tr>
					<td class="black" >{{ $t('lang.Delivery28')}}</td>
					<td class="black">{{ $t('lang.Delivery29')}}</td>
				</tr>
			</table>
			
			
			<br /><br /><br /><br /><hr /><br /><br /><br /><br />
			<h2>{{ $t('lang.Delivery3')}}</h2>
			
				<div slot="header" class="clearfix black1" style="text-align: left;">
					<p class="indent">
					{{ $t('lang.Delivery30')}}
					</p>
				</div>
				<img class="wh100" src="../../../public/pic/product/fooddelivery/AB.png" />
				
				
			<br /><br /><br /><br /><br /><br /><br /><br />
		</div>
	</div>
</template>

<script>
export default {
	head(){
		return {
			title : '送餐机器人_深圳全智能机器人科技有限公司 food delivery robot  _Shenzhen all intelligent robot technology Co., Ltd',
			keywords : '送餐机器人,酒店机器人,餐厅机器人,智能送餐机器人,餐厅送餐机器人,传菜机器人,送餐机器人厂家  food delivery robot, hotel robot,Restaurant robot,Restaurant food delivery robot,Dish passing robot,Food robot manufacturer',
			description : '深圳全智能机器人科技有限公司研发生产的送餐机器人，基于新一代全自主定位导航方案，机器人采用激光slam技术和多传感器，负责餐厅菜品从后厨到餐桌的配送，循环移动到等候区的顾客配送零食，并能用生日蛋糕给生日顾客惊喜，提高服务效率，帮助餐厅优化人员，带来附加增值服务。 the food delivery robot developed by shenzhen all intelligent robot, which is based on the new generation of fully autonomous positioning navigation scheme,are responsible for the delivery of restaurant dishes from kitchen to table , circulating moves to the waiting area to deliver snacks to customers, and it can surprise birthday customers with birthday cakes.  It improves service efficiency, help the restaurant optimize staff, bring additional value-added services',
		};
	},
}
</script>

<style scoped>
	p{
		font-size: 15px;
		text-align: justify;/*外部引人入的不生效*/
	}
	.black{
		color: white;
		height:50px;
		font-size: 20px;
		font-weight: bold;
	}
	.black1{
		line-height: 40px;
		font-size: 18px;
	}
	
	td{
		width: 50%;
	}
</style>
